export const SUPPORTED_LOCALES = ['nl', 'en', 'es', 'fr'] as const;

export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'nl';

export const LOCALE_LABELS: Record<Locale, string> = {
  nl: 'Nederlands',
  en: 'English',
  es: 'Español',
  fr: 'Français',
};

export const LOCALE_DATE_TAGS: Record<Locale, string> = {
  nl: 'nl-NL',
  en: 'en-US',
  es: 'es-ES',
  fr: 'fr-FR',
};

export function isLocale(v: string): v is Locale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(v);
}
